import { createResourceAction } from '../@common/actions/resource-actions';
import { LOGIN, LOGOUT, REFRESH_TOKEN, FETCH_USER } from './constants';
import { LoginPayload } from './index';

export const login = createResourceAction<LoginPayload>(LOGIN);
export const logout = createResourceAction(LOGOUT);
export const refreshToken = createResourceAction(REFRESH_TOKEN);
export const fetchUser = createResourceAction(FETCH_USER);
